import { Inject, Injectable, EventEmitter, Output, PLATFORM_ID, Directive, Injector, makeStateKey, TransferState, HostListener } from '@angular/core';
// import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { throwError, of } from 'rxjs';
import 'rxjs';
import { AppConfigService } from '@citi-gcg-173875/citi-utils';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { GuidService } from 'app/services/guid.service';
import { BackendService } from 'app/services/backend.service';
import { catchError, map, switchMap, take, tap } from 'rxjs/operators';
import { E2eService } from 'app/services/e2e.service';
import * as moment from 'moment-timezone'; // Start PLCN_CTY REMOVE
import { ContentService } from './content.service';
import { routeMapping } from './route-mapping';
import DOMPurify from 'dompurify';
import { DILLARDS_SIGNON_FALLBACK_PATH, DILLARDS_SITE_ID, isSafeDillardsPartnerRedirectUrl } from '../utils/partner-redirect.util';

// State key to store data on server
const BRANDING_DATA_KEY = makeStateKey('brandingData');
const GLOBAL_DATA_KEY = makeStateKey('globalData');
const MODAL_DATA_KEY = makeStateKey('modalData');
const LANG_DATA_KEY = makeStateKey('LangData');
const MODULE_DATA_KEY = makeStateKey('moduleData');
const SIGN_ON_DATA_KEY = makeStateKey('signonData');


@Directive()
@Injectable()
export class SvcServices {
    config: any;
    api: any;
  endpointMap: any;
  channel: any;
  endpoints: Map<string, string>;
  clientId: string = "";
  JWTIndex: string = "";
  interstitialsCollect:any
  securityQuestionsResponse: any;
  screenWidth: number;
  screenHeight: number;
  screenOrientation: string;
  screenCaptureObj: any = {};
  appClientSettings: any = null;
  currentAppSettings: any;



    constructor(private _http: HttpClient,
                private route: ActivatedRoute,
                public _appConfigService: AppConfigService,
                //private _storageService: StorageService,
                private guidService: GuidService,
                private router: Router,
                private transferState: TransferState,
                private _injector: Injector,
                private _e2eService:E2eService,
                @Inject(PLATFORM_ID) private platformId: string,
                @Inject(DOCUMENT) private _document: Document) {
        // const config = this._appConfigService.getConfig("api");
        // const { api } = config;
        // const endpointMap =
        //     Object
        //         .keys(api.endpoints)
        //         .reduce((map, endpoint, i) => {
        //             map[i] = [endpoint, api.endpoints[endpoint]];
        //             return map;
        //         }, []);
        // this.channel = api.channel;
        // this.endpoints = new Map(endpointMap);
        this.setConfig();

    }

    clearCache(): void {
        console.log('Cache cleared for ContentService');
      }

    setConfig() {
        this.config = this._appConfigService.getConfig("api");
        this.api = this.config;
        this.endpointMap =
          Object
            .keys(this.config?.endpoints)
            .reduce((map, endpoint, i) => {
              map[i] = [endpoint, this.config?.endpoints[endpoint]];
              return map;
            }, []);
        this.channel = this.config?.channel;
        this.endpoints = new Map(this.endpointMap);
        this.clientId = this.config?.headers?.client_id;
        this.JWTIndex = this.config?.path;
      }
    // config = this._appConfigService.getConfig("api");
    // api = this.config;
    // endpointMap =
    //     Object
    //         .keys(this.api.endpoints)
    //         .reduce((map, endpoint, i) => {
    //             map[i] = [endpoint, this.api.endpoints[endpoint]];
    //         return map;
    //         }, []);
    // channel = this.api.channel;
    // public endpoints: Map<string, string> = new Map(this.endpointMap);
    pData: any;
    businessId: any;
    brandingContent: any;
    globalData: any;
    branding: any;
    modalData: any;
    contactCenterContent: any;
    isBrowserWhitelabelPage: boolean = false;
    accountId: string = "";
    currentLocaleId: any;
    ssoAuthUrl = 'sso/authorize';
    interstitialName: string;
    get backend(): BackendService {
        return this._injector.get<BackendService>(BackendService);
    }
    get getConfigContent(): ContentService {
        return this._injector.get<ContentService>(ContentService);
    }
    private currentBrandingContent = new BehaviorSubject(null);
    public branding_content = this.currentBrandingContent.asObservable();

    private moduleData = new BehaviorSubject<any>(null);
    public pageData = this.moduleData.asObservable();

    private getGlobalContent = new BehaviorSubject<any>(null);
    public globalContent = this.getGlobalContent.asObservable();

    private modalObservable = new BehaviorSubject<any>(null);
    public getModalContent = this.modalObservable.asObservable();

    private hrvContent = new BehaviorSubject<any>(null);
    public getHrvContent = this.hrvContent.asObservable();

    private getSignOnData = new BehaviorSubject<any>(null);
    public signOnData = this.getSignOnData.asObservable();

    private disableCardSeletorDropDown = new BehaviorSubject<boolean>(false);
    disableCardSelDropDown$ = this.disableCardSeletorDropDown.asObservable();

    @Output() componentLoaded = new EventEmitter<boolean>();
    @Output() triggerDatePicker = new EventEmitter<any>();
    @Output() doDatevalidation = new EventEmitter<any>();
    @Output() isEmailValidated = new EventEmitter<any>();
    @Output() issubmitClicked = new EventEmitter<any>();
    @Output() isSignOnLoaded = new EventEmitter<boolean>();
    @Output() scrollLocked = new EventEmitter<boolean>();
    // to hide language toggle button for confirmation and verification views
    @Output() languageToggleVisibility = new EventEmitter<String>();
    // to hide language toggle button for MIL-CPAY accounts
    @Output() languageSuppressMIL = new EventEmitter<boolean>();
    @Output() productIdContactUs = new EventEmitter<any>();
    visibleNotificationNamePLCN_CTY:any = ""; // Start PLCN_CTY REMOVE

    @HostListener('window:resize', ['$event'])
    getScreenPosition(event?) {
        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
        return this.screenOrientation = this.screenWidth > this.screenHeight ? "landscape" : "portrait";
    }

    fusionHashValues: any = {
        "dispute_charge": "#disputeCharge",
        "payments": "#payments",
        "autopay": "#autopay",
        "add_edit_payment_source": "#addpaymentsrc",
        "manage_payment_sources": "#managepaymentsrc",
        "multiple_payments": "#multiplepayments",
        "promises_to_pay": "#promises_to_pay",
        "make_a_payment_with_options": "#makepaymentoptions",
        "change_due_date": "#changeduedate",
        "reportlostorstolen": "#reportlostorstolen"
    };
    // Need to add all the partners business id details
    businessIdDetails: any = {
		"PLCN_GOODYEAR":"GDYR",
		"GOODYEAR":"GDYR",
		"PLCN_MACYS":"MACY",
		"PLCN_BLOOMINGDALES":"BLMD",
		"PLCN_CTY":"CTY",
		"PLOC_SHELL":"SHLL",
		"PLCN_BESTBUY":"BB",
		"PLCN_HOMEDEPOT":"THD",
		"CACN_HOMEDEPOT":"THD_CA",
		"PLOC_SUNOCO":"SUN",
		"PLOC_EXXONMOBIL":"EXMB",
		"PLCN_BROOKSBROTHERS":"BROOKS",
		"PLCN_LINCOLNSERVICES":"LINC",
		"PLCN_SERVICE":"FRD",
		"PLCN_POLARIS":"PLRS",
		"PLCN_AMERICAN":"AA",
		"PLCN_BRANDSOURCE":"BRND",
		"PLCN_JEWELRY":"JWL",
		"PLCN_OFFICEDEPOT":"OFDPT",
		"PLCN_STAPLES":"STPL",
		"PLCN_TRACTORSUPPLY":"TS",
		"PLCN_DRIVECARD":"DRV",
		"PLOC_WAWA":"WAWA",
		"PLCN_BRP":"BMBDR",
		"PLCN_SERVICECENTRAL":"TBC",
		"PLCN_TORO":"TORO",
		"PLCN_COSTCO":"COSTCO",
        "PLCN_LLBEAN":"LLBEAN",
        "PLCN_MEIJER": "MJ",
        "PLCN_WFCC": "WF",
        "PLCN_HNPE": "HONDA_PE",
        "PLCN_HNPS": "HONDA_PS",
        "PLCN_KAWA": "KAWA",
        "PLCN_CAT": "CAT",
        "PLCN_HOME": "HMF",
        "PLCN_ELECAPPL": "CENA",
        "PLCN_SYW": "SYW",
        "PLCN_CPAY":"CPAY",
        "PLCN_OSTK": 'OS',
        "PLCN_DILLARDS": 'DL'
	}

    pageDefMap: any = {
        "signon": "jCARDS_svc_cw_sign_on",
        "singlesignon": "jCARDS_svc_cw_single_sign_on",
        "browser": "jCARDS_svc_unsupported_browser_upgrade",
        "ssologin": "jCARDS_svc_cw_sign_on",
        "tyRewardsSignon": "jCARDS_svc_cw_sign_on"
    }

    public getDeviceTypeForProactiveCovaChat(){
        let userAgent = window.navigator.userAgent;
        if(userAgent.match(/Android.+Mobile|iPhone|BB10.+Touch|BB10.+Kbd|BlackBerry|Windows.+IEMobile|Opera Mini|Opera Mobi/)){
          console.log("device :: MOBILE");
          return "MOBILE";
        }
        else if(userAgent.match(/Android|iPad|PlayBook|RIM Tablet|Windows.+Touch|Windows NT [0-9.]+; ARM;/)){
          console.log("device :: TABLET");
          return "TABLET";
        }
        else{
            let device = "DESKTOP";
            try{
                if(navigator.platform != null && navigator.platform != undefined && navigator.platform.toLowerCase().indexOf('mac') != -1 && 'ontouchend' in document){
                    device=  (window.screen.width <768) ? "MOBILE" : "TABLET";
                }
            }catch (ex){
                console.log("Exception to find i devices for ios13");
                console.log(ex);
                device = "DESKTOP";
            }
            console.log("device ::  " + device)
            return device;
        }

      }

      public getCovaScreenResolution  = function(cmsConfigScreen) : string{
        let screenView = "large";
        try{
          console.log("check cms screen config :: ");
          console.log(cmsConfigScreen);
          if(cmsConfigScreen){
            let screensize = JSON.parse(cmsConfigScreen);
            console.log("check config screen size :: ");
            console.log(screensize)
            if (window.matchMedia('(max-width:'+ screensize.small +')').matches){
              screenView = 'small';
            } else if (window.matchMedia('(min-width:'+ screensize.mediummin +')').matches && window.matchMedia('(max-width:'+ screensize.mediummax +')').matches) {
              screenView = 'medium';
            } else {
              screenView ='large';
            }
            return screenView;
          }
        }catch (err){
          console.log(err);
          return "screenerror";
        }
      }

    getScreenView(): string {
        var width = window.screen.width;
        var screenView = 'min';
        if (width >= 576 && width < 769) {
            screenView = 'small';
        } else if (width >= 769 && width < 1012) {
            screenView = 'medium';
        } else if (width >= 1012 && width < 1200) {
            screenView = 'large';
        } else if (width >= 1200) {
            screenView = 'max';
        }
        return screenView;
    }

    setParams(data: any) {
        this.pData = data;
    }
    getParams() {
        return this.pData;
    }

    getBusinessID() {
        console.log("getBusinessID() --> "+ this.businessIdDetails[this.pData?.siteId?.toUpperCase()]);
        return this.businessIdDetails[this.pData?.siteId?.toUpperCase()];
    }

    getSiteId() {
      return this.pData?.siteId?.toUpperCase();
    }

    setBrandingContent(data){
        this.currentBrandingContent.next(data);
    }

    getBrandingContent() {

        let langId = this.getLang();

        if(this.transferState.hasKey(BRANDING_DATA_KEY) && this.getCurrentLocale() == langId ) {
            //if transfer state has accounts data, fetch it from transfer state storage
            const res = of(this.transferState.get(BRANDING_DATA_KEY, null as any));

            this.currentBrandingContent.next(res);

            //To be checked to see whether it has to be removed once the call is made
            //this.transferState.remove(BRANDING_DATA_KEY);
            return res;
        }
        else {
            let url = this.endpoints.get('contentServiceBrandingUrl').replace("BUSID", this.getBusinessID());
            this.currentLocaleId = this.changeLangIdForFrenchPartnerCMS(langId);
            console.log("CURRENT_LOCALE_ID", this.currentLocaleId);
            let headers = {
                'uuid': this.guidService.getGuid(),
                'Accept-Language': this.currentLocaleId,
                ...(this.api.headers || {}),

            };
            let headerData = this.headerConfig();
            //url = environment.brandingContenUrl_1+busId+environment.brandingContenUrl_2;
            const httpOptions = {
                headers: headers,
                getStaticContent: false
              };
            console.log("URL from service.ts for getBrandingContent : " + url);
            return this._http.get(url,httpOptions).pipe(
                (res: any) => {
                    let result = res;
                    this.currentBrandingContent.next(result);
                    this.transferState.set(BRANDING_DATA_KEY, result);
                    return result;
                }
            ).pipe(
                catchError((error) => this.handleError(error))
            )
        }
    }

   getAppClientSettings() {
        const contentService = this._injector.get(ContentService);
        return contentService.getConfigFlags().pipe(
            tap(flags =>{
                console.log('getConfigFlag is from tap: '+ flags)
            }),
            switchMap((flags) => {
            // 1. View API (configFlags/retrieve) returned flags -> use directly
            if (flags && Object.keys(flags).length > 0) {
                this.currentAppSettings = flags;
                return of(flags);
            }
            // 2. Fallback: BAU cfg_cw_app_client_settings via getConfigContent(),
            //    mapped into the SAME flat shape the View API returns so consumers
            //    read flags identically.
            console.log('going to callback setting getConfigContent')
            return contentService.getConfigContent().pipe(
                map((res: any) =>  {
                    const   currentAppSettings = res?.content?.CARDS?.config$$cfg_cw_app_client_settings ?? null  ;
                    this.currentAppSettings = currentAppSettings;
                    return currentAppSettings;
                }

                )
            );
            })
        );
    }

    invokeGlobalData() {
        var data = "cwpageName=" + this.pData.pageName + "&siteId=" + this.pData.siteId;
        if (this.pData.langId) {
            data = data + "&langId=" + this.pData.langId;
        }
        //window Id set in session storage by fusion legacy app
        let window_id = this.getWindowIdFromSessionStorage();
        if (window_id) {
            data = data + "&windowId=" + window_id;
        }
        let headerData = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        const httpOptions = {
            headers: headerData,
            getStaticContent: false
        };
        return this._http.post(this.endpoints.get('globalDataURL'), data, httpOptions)
            .pipe(
                map((res: any) => {
                    let result = res;
                    this.getGlobalContent.next(result);
                    return result;
                }),
                catchError((error) => {
                    if (error.status === 401) {
                        return throwError(error.status);
                    } else {
                        return this.handleError(error);
                    }
                })
            );
    }

    invokeSignOnData() {
        // To fecth the sign on page reponse from legacy
        let langId = this.getLang();
        if(this.transferState.hasKey(SIGN_ON_DATA_KEY) && this.getCurrentLocale() == langId ) {
            //if transfer state has accounts data, fetch it from transfer state storage
            const res = of(this.transferState.get(SIGN_ON_DATA_KEY, null as any));
            this.getSignOnData.next(res);
            return res;
        }
        else {

        var data = "cwpageName=" + this.pData.pageName + "&siteId=" + this.pData.siteId;
        if (this.pData.langId) {
            data = data + "&langId=" + this.pData.langId;
        }
        //window Id set in session storage by fusion legacy app
        let window_id = this.getWindowIdFromSessionStorage();
        if (window_id) {
            data = data + "&windowId=" + window_id;
        }
        let headerData = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };
        console.log("URL from service.ts for invokeSignOnData" + this.endpoints.get('signOnDataURL'));
        const httpOptions = {
            headers: headerData,
            getStaticContent: false
          };
        return this._http.post(this.endpoints.get('signOnDataURL'), data, httpOptions).pipe(
            (res: any) => {
            this.getSignOnData.next(res);
            return res;
            }
        ).pipe(
            catchError((error) => {
                if (error.status === 401) {
                    return throwError(error.status)
                } else {
                    this.handleError(error);
                }
            })
        )
    }
    }

    getModuleContent(pageDef?: string) {

        let langId = this.getLang();

        if(this.transferState.hasKey(MODULE_DATA_KEY) && this.getCurrentLocale() == langId) {
            //if transfer state has accounts data, fetch it from transfer state storage
            const res = of(this.transferState.get(MODULE_DATA_KEY, null as any));
            this.moduleData.next(this.transferState.get(MODULE_DATA_KEY, null as any));
            //To be checked to see whether it has to be removed once the call is made
            //this.transferState.remove(MODULE_DATA_KEY);
            return res;
        }
        else {
            var page_def = this.pageDefMap[this.pData.pageName];
            if (pageDef) {
                page_def = pageDef;
            }
            let url = this.endpoints.get('contentServicePageDefUrl').replace("BUSID", this.getBusinessID()).replace("PAGEDEF", page_def);
            this.currentLocaleId = this.changeLangIdForFrenchPartnerCMS(langId);
            console.log("CURRENT_LOCALE_ID", this.currentLocaleId);
            let headers = {
                'uuid': this.guidService.getGuid(),
                'Accept-Language': this.currentLocaleId,
                ...(this.api.headers || {}),

            };
            console.log("URL from service.ts for getModuleContent" + url);
            let headerData = this.headerConfig();
            return this._http.get(url, { headers: headers}).pipe(
                (res: any) => {
                    let result = res;
                    this.moduleData.next(result);
                    this.transferState.set(MODULE_DATA_KEY, result);
                    return result;
                }
            ).pipe(
                catchError((error) => this.handleError(error))
            )
        }
    }


    invokeModalContentCall(pageDef?: string) {


        let langId = this.getLang();

        if(this.transferState.hasKey(MODAL_DATA_KEY) && this.getCurrentLocale() == langId) {
            //if transfer state has accounts data, fetch it from transfer state storage
            const res = of(this.transferState.get(MODAL_DATA_KEY, null as any));
            this.modalObservable.next(this.transferState.get(MODAL_DATA_KEY, null as any));
            //To be checked to see whether it has to be removed once the call is made
            //this.transferState.remove(MODAL_DATA_KEY);
            return res;
        }
        else {
            let page_def = this.pageDefMap[this.pData.pageName];
            if (pageDef) {
                page_def = pageDef;
            }
            let url = this.endpoints.get('contentServicePageDefUrl').replace("{BUSID}", this.getBusinessID()).replace("{PAGEDEF}", page_def);
            this.currentLocaleId = this.changeLangIdForFrenchPartnerCMS(langId);
            console.log("CURRENT_LOCALE_ID", this.currentLocaleId);
            let headers = {
                'uuid': this.guidService.getGuid(),
                'Accept-Language': this.currentLocaleId,
                ...(this.api.headers || {}),

            };
            console.log("URL from service.ts for invokeModalContentCall" + url);
            let headerData = this.headerConfig();
            return this._http.get(url, { headers: headers}).pipe(
                (res: any) => {
                    let result = res;
                    this.modalObservable.next(result);
                    this.transferState.set(MODAL_DATA_KEY, result);
                    return result;
                }
            ).pipe(
                catchError((error) => this.handleError(error))
            )
        }
    }

    getHrvModalContent(pageDef?: string){
        var page_def = this.pageDefMap[this.pData.pageName];
        if (pageDef) {
            page_def = pageDef;
        }
        let url = this.endpoints.get('contentServicePageDefUrl').replace("BUSID", this.businessId).replace("PAGEDEF", page_def);
        let headers = {
            'uuid': this.guidService.getGuid(),
            'Accept-Language': this.getLang(),
            ...(this.api.headers || {}),

        };
        console.log("URL from service.ts for getHrvModalContent" + url);
        let headerData = this.headerConfig();
        return this._http.get(url, {headers: headers}).pipe(
            (res: any) => {
                let result = res;
                this.hrvContent.next(result);
                return result;
            }
        ).pipe(
            catchError((error) => this.handleError(error))
        )
    }

    sendCardDetails(cData) {
        //let headerData = this.headerConfig();
        let headerData = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };
        const httpOptions = {
            headers: headerData,
            getStaticContent: false
          };
        return this._http.post(this.endpoints.get('globalDataURL'), cData, httpOptions).pipe(
            (res: any) => {
                let result = res;
                return result;
            }
        ).pipe(
            catchError((error) => this.handleError(error))
        )
    }

    //keep alive call for fusion
    fusionKeepAliveCall() {
        let headerData = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };
        const httpOptions = {
            headers: headerData,
            getStaticContent: false
          };
        return this._http.get(this.endpoints.get('keepalive'), httpOptions).pipe(
            (res: any) => {
                let result = res;
                return result;
            }
        ).pipe(
            catchError((error) => this.handleError(error))
        )
    }

    fusionTimeOutCall() {
        var data = "siteId=" + this.pData.siteId;
        data = data + "&mode=timeout";
        //window Id set in session storage by fusion legacy app
        let window_id = this.getWindowIdFromSessionStorage();
        if (window_id) {
            data = data + "&windowId=" + window_id;
        }
        let headerData = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };
        return this._http.post('/RSnextgen/svc/launch/timeout.action', data, { headers: headerData }).pipe(
            (res: any) => {
                let result = res;
                return result;
            }
        ).pipe(
            catchError((error) => this.handleError(error))
        )
    }


    pageContent: any

    setModuleContent(data) {
        this.pageContent = data;
    }

    setSignOnData(data) {
        this.signOnData = data;
    }


    getContent() {
        return this.pageContent;
    }

    hrvModalContent: any

    setHRVContent(data){
        this.hrvModalContent = data;
    }

    getHRVContent() {
        return this.hrvModalContent;
    }

    moduleRestarted: boolean = false;
    setModuleRestarted(restart: boolean) {
        this.moduleRestarted = restart;
    }
    getModuleRestarted(): boolean {
        return this.moduleRestarted;
    }

    getClientIdfromHeader() {
        let clientIdValue = this.config.api.headers.client_id;
        return clientIdValue;
    }

    /**
     *
     * @param contentId - content id
     * @param type - copy, cmcomponent, cmlink
     * @param attribute - TEXT, WCAG_TEXT
     */
    getSelectiveContent(contentId, type, attribute) {
        let copyTxt = '';
        if (this.pageContent && this.pageContent[type + "$$" + contentId]) {
            copyTxt = this.pageContent[type + "$$" + contentId][attribute];
        }
        return copyTxt;
    }

    /**
     * Returns the TEXT value for given content Id
     * @param contentId - content id
     */
    getCopyTxt(contentId) {
        let copyTxt = '';
        if (this.pageContent && this.pageContent["copy$$" + contentId]) {
            copyTxt = this.pageContent["copy$$" + contentId]["TEXT"];
        }
        return copyTxt;
    }


    headerConfig() {
        let headerParam = {
            'Content-Type': 'application/json',
            "uuid": this.guidService.getGuid(),
            "client_id": this.getClientIdfromHeader,
            "businessCode": 'CRS',
            "Accept-Language": 'en-US',
            "countryCode": 'US'
        };
        return headerParam;
    }

    handleError(error: any) {
        return throwError(error)
    }

    getCookieValue(key: string) {
        let cookie = document.cookie.split(';');
        for (let i = 0; i < cookie.length; i++) {

            if (cookie[i].trim().startsWith(key)) {
                return cookie[i].trim().split(key + "=")[1];
            }
        }
    }

    getChannel() {
        if (this.channel === 'RPLID' && this.pData && !this.pData.jwt) {
            return 'STANDALONE'
        } else {
            return this.channel;
        }
    }

    getSourceApplicationId() {
        if (this.pData && this.pData.siteId) {
            if (this.pData.siteId.toLowerCase() == 'app_ucd') {
                return 'UCD';
            } else {
                return this.channel;
            };
        }
    }

    getpreferredLanguageCode() {
        if (this.pData.langId && this.pData.langId === 'es_US') {
            return 'es';
        } else {
            return 'en';
        }
    }

    getFusionBookmarkUrl() {
        let pageName = this.pData.pageName;
        let fusionHash = this.fusionHashValues[pageName];
        let redirectURL = "/RSnextgen/svc/launch/index.action?siteId=" + this.pData.siteId;
        if (this.pData.langId) {
            redirectURL = redirectURL + "&langId=" + this.pData.langId;
        }
        return redirectURL + "&pagename=authenticate" + fusionHash;

    }

    isFusionChannel() {
        let isFusion = false;
        if ('FUSION' === this.getChannel() && ('app_rplid' !== this.pData?.siteId?.toLowerCase() && 'app_ucd' !== this.pData?.siteId?.toLowerCase())) {
            isFusion = true;
        }
        return isFusion;
    }

    setBusinessId(busId: string) {
        this.businessId = busId;
    }

    getLanguaugeOption(): string {
        let language: string = "ENGLISH";
        if (this.pData && this.pData.langId) {
            if ("es_US" === this.pData.langId) {
                language = "SPANISH";
            }
        }
        return language;
    }

    getWindowIdFromSessionStorage(): string {
        let window_id: string;
        try {
            window_id = sessionStorage.getItem('window_id');
            if (!window_id) {
                window_id = String(Date.now());
            }
        } catch (err) {
            console.log("Session storage not supported");
        }
        return window_id;

    }

    getNotificationsFromSessionStorage(): string {
        let notifications: any;
        let notificationngasignon: any;
        try {
             notifications = sessionStorage.getItem('notifications') ? JSON.parse(sessionStorage.getItem('notifications')) : [];
             notificationngasignon = sessionStorage.getItem('notificationngasignon') ? JSON.parse(sessionStorage.getItem('notificationngasignon')) : [];

            if (notificationngasignon.length > 0) {
                notifications = [...notifications, ...notificationngasignon];
            }
            notifications = JSON.stringify(notifications)
            console.log('notification sign on deny');
            console.log(notifications)
        } catch (err) {
            console.log("Session storage not supported");
        }
        return notifications;

    }

    removeNotificationsFromSessionStorage(){
            try {
                sessionStorage.removeItem('notifications');
                if(sessionStorage.getItem('notificationngasignon')){
                    sessionStorage.removeItem('notificationngasignon');
                }
                console.log("notifications removed from Session storage");

            } catch (err) {
                console.log("exception in notifications remove");
            }
        }

    //for triggering page level notification
    @Output() triggerNotification = new EventEmitter<any>();
    @Output() triggerNotificationClose = new EventEmitter<any>();

    triggerPageLevelNotification(notificationData) {
        /* expected format for triggering page level notification
        let notificationData={
            nameOfThePopup:'disputeSubmitted',
            type:'success',
            isDismissable: false,
            message:"Your request to dispute a charge has been submitted. Once we've reviewed it, you'll be notified of next steps."
        // }*/
        this.triggerNotification.emit(notificationData);
    }

    triggerClosePageLevelNotification(notificationName) {
        this.triggerNotificationClose.emit(notificationName);
    }

    //Cancel Button Click for Fusion - Redirect
    redirectFromDispute(pageName, siteId) {
        setTimeout(()=>{
            let locale = localStorage.getItem("siteLocal_ID") ? localStorage.getItem("siteLocal_ID") : 'en_US';
            window.location.href = '/RSnextgen/svc/launch/index.action?siteId=' + siteId + '&langId=' + locale + '&pagename=authenticate#' + pageName;
        },250);
  }

  //FUsion lost or stolen redirect
  redirectToFusionLostOrStolen() {
    this.router.navigate(['/lostorstolen'], { queryParams: { pageName: 'reportlostorstolen' }, queryParamsHandling: 'merge' });
  }
    // Redirecting to Lost or Stolen module for RPLID after the account search
    redirectToLostOrStolen() {

        this.router.navigate(['/contact-center'], { queryParams: { pageName: 'reportlostorstolen' }, queryParamsHandling: 'merge' });
    }
    // Redirecting to Dispute module for RPLID after the agent clicks on Select another account from lost or stolen module
    redirectToDispute() {

        this.router.navigate(['/contact-center'], { queryParams: { pageName: 'disputecharge' }, queryParamsHandling: 'merge' });
    }

    redirectToSignon(hash?: string): void {
        const { siteId, langId } = this.getParams();
        let signOnUrl = '/RSnextgen/svc/launch/index.action?siteId=' + siteId;
        if (langId) {
          signOnUrl = signOnUrl + '&langId=' + langId;
        }
        window.location.href = signOnUrl + (hash ? hash : '#signon');
    }



    //Bring back the button to original state by removing spinner
    @Output() endSpinner = new EventEmitter<boolean>();

    //Emit the length of Filtered Transaction List
    @Output() triggerFilterListLen = new EventEmitter<any>();

    triggerProcessCompletionForSpinner(processCompleted) {
        this.endSpinner.emit(processCompleted);
    }

    passFilteredTransListLen(len) {
        this.triggerFilterListLen.emit(len);
    }

    scrollToTop() {
        window.document.body.scrollTop = 0;
        window.document.documentElement.scrollTop = 0;
    }

    getPagedefContentId(): string {
        return this.pageDefMap[this.pData.pageName];
    }
	getSignonDatalayer() {
        var dataLayerConst:any= {};
        var brandIdValue: String= "";
        if(this.route.snapshot.queryParams.brandId !== undefined){
        brandIdValue = this.route.snapshot.queryParams.brandId;
        } else {
        brandIdValue = "";
        }
		var dataLayer = {
			pageName: this.pData.pageName,
            siteId: this.pData?.siteId?.toUpperCase(),
            brandId: brandIdValue,
			langId: this.getLang(),
			partnerCSS : this.pData?.siteId?.toUpperCase() + '_dmar.min.css'
		}
		dataLayerConst.dataLayer=dataLayer;
		return dataLayerConst;
	}

    getGlobalData() {
        const pageName = this.pData.pageName;
        return pageName === "signon" || pageName === "singlesignon" || pageName === "ssologin" || pageName === "tyRewardsSignon"
            ? this.getSignonDatalayer()
            : this.getGlobalContent.value;
    }

    getAccountId(): string {
        if ('FUSION' === this.channel) {
            return this.accountId;
        } else {
            return this.route.snapshot.queryParams.accountId ? this.route.snapshot.queryParams.accountId : '';
        }

    }

    /**
     * Returns the last four digits of the account number.
     * For fusion  reads from gloabl data call response
     * For other channels accountId will  be available in url
     */
    getAccountLastFourDigit(): string {
        let accountLastFour: string = ""
        if (this.isFusionChannel()) {
            let globalData = this.getGlobalData();
            if(globalData && globalData.maskedAccountNumber && globalData.maskedAccountNumber.length>4) {
                let account = globalData.maskedAccountNumber;
                accountLastFour = account.substring(account.length-4);
            }
        }else {
            if(this.route.snapshot.queryParams.accountId && this.route.snapshot.queryParams.accountId.length>4) {
                let account = this.route.snapshot.queryParams.accountId;
                accountLastFour = account.substring(account.length-4);
            }
        }
        return accountLastFour;
    }

    setAccountId(accountId: string) {
        this.accountId = accountId;
    }


    //Formatting the amount  to  2 decimal places
    amountFixedTo(value: (number | string), currencyCode?: string, optionalValueToBeReturn?: number) {
        const negative = (Number(value) < 0) ? '-' : '';
        const amount = value == null ? optionalValueToBeReturn.toString() : parseFloat(('' + value).replace(/[^0-9\.]*/i, '')).toString();
        const USD = {
            currencySymbol: '',
            decimalMark: '.',
            thousandsSeparator: ','
        };
        const denomination = this[currencyCode] || USD;
        const whole = amount
            .split('.')[0]
            .split('')
            .reverse()
            .map((number, index, array) => {
                return (index + 1) % 3 === 0 && (index + 1) < array.length ? denomination.thousandsSeparator + number : number;
            })
            .reverse()
            .join('');
        const fractional = (amount.indexOf('.') > 0 ? amount : amount + '.')
            .replace(/([^\.]*)\.([0-9]*)$/, '$200')
            .substr(0, 2);
        return value == null ? optionalValueToBeReturn : negative + denomination.currencySymbol + whole + denomination.decimalMark + fractional;

    }

    getLang() {
        if(this.pData?.siteId?.toLowerCase() === 'cacn_homedepot'){
            return this.pData.langId ? this.pData.langId : 'en_CA';
        } else {
            return this.pData.langId ? this.pData.langId : 'en_US';
        };
    }

    getCurrentLocale() {
        if(isPlatformBrowser(this.platformId)) {
            const localSiteId = localStorage.getItem("siteLocal_ID");
            if(this.pData && this.pData.siteId && this.pData.siteId.toLowerCase() === 'cacn_homedepot'){
              return localSiteId ? localSiteId : "en_CA";
            } else {
              return localSiteId ? localSiteId : "en_US";
            }
          } else {
            return this.getLang();
          }
    }

    notifyFusion(data?: any) {
        if(this.isFusionChannel()) {
            try {
                let headerData = {
                    'Content-Type': 'application/x-www-form-urlencoded'
                };
                return this._http.post(this.endpoints.get('fusionNotifyUrl'), data, { headers: headerData }).pipe(
                    (res: any) => {
                        return res;
                    }
                ).pipe(
                    catchError((error) => of(true))
                )
            }
            catch (ex) {
                console.log('Exception in fusionNotifyCall' + ex);
            }
        }else {
            return of(true);
        }

    }

    sourceAdded: boolean  =false;

    setSourceAdded(sourceAdded: boolean) {
        this.sourceAdded = sourceAdded;
    }


    getSourceAdded(): boolean {
        return this.sourceAdded;
    }

    isAdBlockerEnabled(): boolean {
        // Element is created in assets/lib/ads.js
        // If ads.js is blocked, element will be missing

        if(!document){
            return false;
        }

        if(document.getElementById('tDhEfWvIpauT')){
            return false;
        } else {
            return true;
        }
    }

    createKnownUserKey(): void {
        //Called when user successfully logins
        const partnerLoggedInKey = 'signed_on_' + this.getBusinessID();
        if(!localStorage.getItem(partnerLoggedInKey)){
            localStorage.setItem(partnerLoggedInKey, "true");
        }
    }

    isKnownUser(): boolean {
        //Check if user successfully logged in before
        const partnerLoggedInKey = 'signed_on_' + this.getBusinessID();
        if(localStorage.getItem(partnerLoggedInKey)){
            return true;
        } else {
            return false;
        }
    }

    isUnknownUser(): boolean {
        //Check if user successfully logged in before
        const partnerLoggedInKey = 'signed_on_' + this.getBusinessID();
        if(localStorage.getItem(partnerLoggedInKey)){
            return false;
        } else {
            return true;
        }
    }

    getKoreBotMessageURl(){
        var config = this._appConfigService.getConfig("api");
        var url = config.endpoints.KoreBotMessageURl;
        return url;
    }

    /* Synchronous flag read for callers that run before the constructor's
       getAppClientSettings() subscription has emitted. Falls back to the
       hydrated flags / BAU cfg_cw_app_client_settings held by ContentService. */
    private getKorePlatformUrlUpdateEnabled(): any {

            return this.currentAppSettings?.kore_platform_url_update_enabled || this.getConfigContent?.getConfigFlagsSync?.()?.kore_platform_url_update_enabled;


    }

    getkoreWebSocketCloudUrl(){
        const korePlatformEnabled = this.getKorePlatformUrlUpdateEnabled();
        var config = this._appConfigService.getConfig("api");
        if(korePlatformEnabled && String(korePlatformEnabled).toLowerCase() === 'true') {
            return config.endpoints.KoreBotPlatformMessageURl;
        }
        var url = config.endpoints.koreWebSocketCloudUrl;
        return url;
    }

    getTaskBotId(){
        // get botid for task
        var config = this._appConfigService.getConfig("api");
        var id = config.endpoints.taskBotId;
        return id;
    }

    getcloudBotId(isEnabled?: boolean){
        var config = this._appConfigService.getConfig("api");
        const cloudBotEnabled = this.getKorePlatformUrlUpdateEnabled();
        if(cloudBotEnabled && String(cloudBotEnabled).toLowerCase() === 'true') {
            return config.endpoints.platformcloudBotId;
        }
        var id = config.endpoints.cloudBotId;
        return id;
    }

    getTmxOrgId(){
        return this.endpoints.get('tmxOrgId');
    }

    getSiteCatAccount(accountType: any){
        return this.endpoints.get(accountType);
    }

    public isIEorEdge(): boolean {
      let userAgentString = window.navigator.userAgent;
      // Detect Edge
      let edgeAgent = userAgentString.indexOf("Edge") > -1;

      // Detect Internet Explorer
      let IExplorerAgent =
        userAgentString.indexOf("MSIE") > -1 ||
        userAgentString.indexOf("rv:") > -1;

      // Detect Firefox
      let firefoxAgent = userAgentString.indexOf("Firefox") > -1;

      if (IExplorerAgent && firefoxAgent) IExplorerAgent = false;

      return edgeAgent || IExplorerAgent;

    }

    changeLangIdForFrenchPartnerCMS(currentLocaleId){
        if(this.pData && this.pData.siteId && this.pData.siteId.toLowerCase() === 'cacn_homedepot'){
            if(currentLocaleId === 'en_CA' || currentLocaleId === 'en_US'){
                return currentLocaleId = 'ca_US';
            } else if (currentLocaleId === 'fr_CA' || currentLocaleId === 'fr_US'){
                return currentLocaleId = 'fr_US';
            } else {
                return currentLocaleId;
            }
        } else {
            if(currentLocaleId === 'en_CA'){
                return currentLocaleId = 'ca_US';
            } else if (currentLocaleId === 'fr_CA'){
                return currentLocaleId = 'fr_US';
            } else {
                return currentLocaleId;
            }
        }
    }


    postForm(path,params){
          if(!path) {
            console.log("endpoint not found!");
            return;
          }

          let form = document.createElement('form');
          form.setAttribute('method','post');
          form.setAttribute('action',path);

          for(let key in params){
            let hiddenField = document.createElement('input');
            hiddenField.setAttribute('type','hidden');
            hiddenField.setAttribute('name',key);
            hiddenField.setAttribute('value',params[key]);
            form.appendChild(hiddenField);
          }

          document.body.appendChild(form);
          form.submit();
    }

    /** The Dillards return host checks only apply to requests made for the Dillards site. */
    private isDillardsRequest(): boolean {
        return this.pData?.siteId?.toUpperCase() === DILLARDS_SITE_ID;
    }

    /**
     * Validates a partner return URL against the Dillards return hosts configured for this
     * environment before it is used to navigate the browser away from Citi.
     */
    private isSafePartnerRedirectUrl(url: string | null | undefined): url is string {
        return isSafeDillardsPartnerRedirectUrl(url, this.getRuntimeDillardsHosts());
    }

    /**
     * Reads the Dillards return hosts from the runtime app config (selected per environment by the
     * server), falling back to `undefined` so the util uses its statically bundled default.
     */
    private getRuntimeDillardsHosts(): string[] | undefined {
        const hosts = this._appConfigService.getConfig('dillardsPartnerRedirectHosts');
        return Array.isArray(hosts) ? hosts : undefined;
    }

    /**
     * Navigates to the partner return URL only when it is registered; otherwise the browser
     * stays on Citi and lands on the Dillards signon page.
     */
    private safeRedirectToPartner(): void {
        const partnerRedirectUrl = this.pData?.partnerRedirectUrl;
        if (this.isSafePartnerRedirectUrl(partnerRedirectUrl)) {
            this.navigateTo(partnerRedirectUrl);
            return;
        }
        console.error('Rejected unregistered partnerRedirectUrl:', partnerRedirectUrl);
        this.redirectToDillardsSignonWithError();
    }

    /**
     * Lands on the Dillards signon page with the CMS error notification flagged, so the page
     * explains that the request could not be processed instead of showing a bare signon form.
     */
    private redirectToDillardsSignonWithError(): void {
        try {
            const alertMSG = this.getEncounteredAProblemCopy();
            if (alertMSG) {
                sessionStorage.setItem('notifications', JSON.stringify([{ alertType: 'urgent', alertMSG }]));
            }
        } catch (e) {
            console.warn('Failed to store the signon error notification', e);
        }
        this.navigateTo(window.location.origin + DILLARDS_SIGNON_FALLBACK_PATH);
    }

    /* Content id holding the "we encountered an error processing your request" copy. */
    private getEncounteredAProblemCopy(): string {
        return this.getCopyTxt('err_notification_encountered_a_problem');
    }

    private navigateTo(url: string): void {
        window.location.href = url;
    }

    getAuthorizeToken(): Observable<any>{
        // getAuthorizeToken method
        if (this.isDillardsRequest() && !this.isSafePartnerRedirectUrl(this.pData?.partnerRedirectUrl)) {
            console.error('Rejected unregistered partnerRedirectUrl, skipping SSO authorize:', this.pData?.partnerRedirectUrl);
            this.redirectToDillardsSignonWithError();
            return of(false);
        }

        try {

                console.log('svc service getAuthorizeToken this.pData.partnerUserId -->>'+this.pData.partnerUserId);
                let headerData = {
                'Content-Type': 'application/x-www-form-urlencoded',
                'accept': 'application/json',
                'uuid': this.guidService.getGuid(),
                'channelId': 'QUARTZ',
                'countryCode':'US',
                'businessCode':'CRS',
                "client_id": this.config.headers.client_id,

                };

                sessionStorage.setItem("ssoPartnerUserId", this.pData.partnerUserId);
                sessionStorage.setItem("ssoPartnerRedirectUrl", this.pData.partnerRedirectUrl);
                sessionStorage.setItem("ssoState", this.pData.state);
                sessionStorage.setItem("isExpiredRefreshToken", this.pData.isExpiredRefreshToken);
                const request = new URLSearchParams();
                request.set('client_id',this.pData.client_id);
                request.set('response_type','token');
                request.set('scope',this.pData.scope);
                request.set('state',this.pData.state);
                request.set('redirect_uri',this.pData.partnerRedirectUrl);
                request.set('request_uri',this.pData.request_uri);

                return this.backend.postFormURLEncoded(this.ssoAuthUrl,  request.toString(), {headers: headerData})
                .pipe(
                    catchError((error: any) => {
                        return of(false);
                    }),
                    map(data => {
                    if (data !== null && data !== undefined) {
                        if(data.status === 200){
                            if(!this._e2eService.e2eConfig){
                                this._e2eService.getE2eConfig().subscribe(() => { });
                                console.log('SSO FSVC CALL');
                            }

                            if(!this._e2eService.sRKeyVal){
                                this._e2eService.initE2e({
                                    channelId: 'QUARTZ',
                                }).subscribe(() => { });
                                console.log('SSO KEY CALL');
                            }
                            sessionStorage.setItem("ngaSsoAuthCode", data.citi_authorization);
                            sessionStorage.setItem("signOnkeyAuthCode", data.access_token);

                            const redirectUrl = window.location.origin+"/RSauth/signon?pageName=singlesignon&siteId=PLCN_DILLARDS&langId=en_US";
                            console.log('Redirecting to SSO authorize success');
                            window.location.href = redirectUrl;
                        }
                        else {
                            console.log('authorize response==> not 200');
                            this.safeRedirectToPartner();
                        }
                        } else {
                        console.log('authorize res data null or empty');
                        this.safeRedirectToPartner();
                        }

                    })
                );
            }
            catch (ex) {
                console.log('Exception in fusionNotifyCall' + ex);
            }
    }

    // Start PLCN_CTY REMOVE
    featureDisabledDate_plcn_cty(feature_decommission_plcn_cty): boolean {
        console.log("ui-comp feature disable");
        //const siteId = this._svcService.getSiteId();
        //const PLCN_CTY = 'SEARS'; // PLCN_CTY
        let canShow = false;
        const EST_TZ = "America/New_York";
        let startDate: any;
        let endDate: any;
        let now: any = moment.tz(EST_TZ);
        if (feature_decommission_plcn_cty &&
          feature_decommission_plcn_cty.Start_Date && feature_decommission_plcn_cty.Start_Time &&
          feature_decommission_plcn_cty.End_Date && feature_decommission_plcn_cty.End_Time ) {
          startDate = moment.tz(feature_decommission_plcn_cty.Start_Date + ' ' + feature_decommission_plcn_cty.Start_Time, EST_TZ);
          endDate = moment.tz(feature_decommission_plcn_cty.End_Date + ' ' + feature_decommission_plcn_cty.End_Time, EST_TZ);
          canShow = now.isSameOrAfter(startDate) && now.isSameOrBefore(endDate);
          //let isbeetween = now.isBetween(startDate, endDate);
          //console.log("isbeetween==",isbeetween);
          console.log("PLCN_CTY Feature Decommission canShow:", canShow)
        }
        return canShow;
      }

      getWindowId(): string | null {
        if (typeof window !== 'undefined' && typeof sessionStorage !== 'undefined') {
          if (sessionStorage.getItem('window_id') == null) {
            let S4 = function() {
              return (Math.floor(Math.random() * 0x10000).toString(16));
            };
            let windowId = 'GUID-' + (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
            sessionStorage.setItem('window_id', windowId);
          }
          return sessionStorage.getItem('window_id');
        }
        return null;
    }

      check_featureDisabled_during_migration(feature_decommission_plcn_cty,plcn_cty_featureDisabled_during_migration): boolean {
        console.log("ui-comp feature disable");
        //const siteId = this._svcService.getSiteId();
        //const PLCN_CTY = 'SEARS'; // PLCN_CTY
        let canShow = false;
        const EST_TZ = "America/New_York";
        let startDate: any;
        let endDate: any;

        let startMigrationDateTime: any;
        let endMigrationDateTime: any;
        let now: any = moment.tz(EST_TZ);
        if (feature_decommission_plcn_cty &&
          feature_decommission_plcn_cty.Start_Date && feature_decommission_plcn_cty.Start_Time &&
          feature_decommission_plcn_cty.End_Date && feature_decommission_plcn_cty.End_Time ) {
          startDate = moment.tz(feature_decommission_plcn_cty.Start_Date + ' ' + feature_decommission_plcn_cty.Start_Time, EST_TZ);
          endDate = moment.tz(feature_decommission_plcn_cty.End_Date + ' ' + feature_decommission_plcn_cty.End_Time, EST_TZ);

          //startMigrationTime = plcn_cty_featureDisabled_during_migration.Start_Time;
          //endMigrationTime = plcn_cty_featureDisabled_during_migration.End_Time;

          startMigrationDateTime =  moment.tz(plcn_cty_featureDisabled_during_migration?.Start_Date + ' ' + plcn_cty_featureDisabled_during_migration?.Start_Time, EST_TZ)
          endMigrationDateTime =  moment.tz(plcn_cty_featureDisabled_during_migration?.End_Date + ' ' + plcn_cty_featureDisabled_during_migration?.End_Time, EST_TZ)


          /*const currentDate = new Date();
          let getMonth: any = currentDate.getMonth();
          const month = (parseInt(getMonth)+ 1).toString().length === 1 ? "0"+(parseInt(getMonth)+1)  : parseInt(getMonth) + 1;
          console.log(month);
          const currentDateFull = `${currentDate.getFullYear()}-${month}-${currentDate.getDate()}`;
          console.log(currentDateFull);
          let curDStart = moment.tz(currentDateFull +" "+ startMigrationTime, EST_TZ);
          let curDEnd = moment.tz(currentDateFull +" "+ endMigrationTime, EST_TZ);*/
          console.log(startMigrationDateTime);
          console.log(endMigrationDateTime);
          canShow = now.isBetween(startMigrationDateTime, endMigrationDateTime) && now.isSameOrAfter(startDate) && now.isSameOrBefore(endDate);
          console.log("PLCN_CTY featureDisabled_within_greenzone_time:", canShow)
        }
        return canShow;
      }

      infoNotificationMessage_90Days_pre_post_login(info_decommission_90_days_notification,during_migration_pre_login_90_days_notification) {
        console.log("ui-comp infoNotificationMessage_90Days_pre_post_login");
        //const siteId = this._svcService.getSiteId();
        //const PLCN_CTY = 'SEARS'; // PLCN_CTY
        let canShow = false;
        let accountId = this.getAccountId();
        const EST_TZ = "America/New_York";
        let startDate: any;
        let endDate: any;
        let now: any = moment.tz(EST_TZ);
        if (info_decommission_90_days_notification &&
          info_decommission_90_days_notification.Start_Date && info_decommission_90_days_notification.Start_Time &&
          info_decommission_90_days_notification.End_Date && info_decommission_90_days_notification.End_Time ) {
          startDate = moment.tz(info_decommission_90_days_notification.Start_Date + ' ' + info_decommission_90_days_notification.Start_Time, EST_TZ);
          endDate = moment.tz(info_decommission_90_days_notification.End_Date + ' ' + info_decommission_90_days_notification.End_Time, EST_TZ);
          canShow = now.isSameOrAfter(startDate) && now.isSameOrBefore(endDate);

            if (canShow) {
              if (during_migration_pre_login_90_days_notification) {
                //this.visibleNotificationNamePLCN_CTY.push(during_migration_pre_login_90_days_notification);
                this.visibleNotificationNamePLCN_CTY = during_migration_pre_login_90_days_notification;
              }
           }
           console.log("PLCN_CTY visibleNotificationNamePLCN_CTY:", this.visibleNotificationNamePLCN_CTY)
        }
        return this.visibleNotificationNamePLCN_CTY;
      }
      //End

    isCovaCloudChatEnabled(enabledList: string): boolean {
        let flag: boolean = false;
        if (enabledList?.toUpperCase().includes(this.pData?.siteId?.toUpperCase())) {
            flag = true;
        }
        return flag;
    }

    isHelpModuleDisabledCOVA(): boolean {
        let disabled = false;
        const faqValidSiteIds = ['PLCN_MACYS', 'PLCN_BLOOMINGDALES'];
        if (this.isFusionChannel() && this.getGlobalData()
            && this.getGlobalData().signedOn === "true"
            && this.getGlobalData().partnerEnabledForCOVAReactive === true
            && this.getGlobalData().faqEnabledPartnerForCOVA === false
            && this.getLang() === 'en_US' && this.pData.pageName !== 'statements' && this.pData.pageName !== 'promodetails' && this.pData.pageName !== 'promoallocation') {
            disabled = true;
            if (this.getSiteId() === 'PLCN_BESTBUY'
                && this.pData.pageName === 'offers') {
                disabled = true;
            }
        }
        else if (this.isFusionChannel() && this.getGlobalData()
            && this.getGlobalData().signedOn === "true"
            && this.getGlobalData().partnerEnabledForCOVAReactive === true
            && this.getGlobalData().faqEnabledPartnerForCOVA === true
            && this.getLang() === 'en_US' && (this.pData.pageName == 'manageaccount' || this.pData.pageName == 'add_authorized_users' || this.pData.pageName == 'credithome') && faqValidSiteIds.includes(this.getSiteId())) {
            disabled = true;
        }
        return disabled;
    }

    setInterstitalName(flowName) {
        this.interstitialName = flowName;
    }

    getInterstitalName() {
        return this.interstitialName;
    }

    getFlowName() {
        // tempoary method to check flow with url, will change with better method
        if (this.router.url.includes('registration')) {
            return 'registration';
        } else if (this.router.url.includes('fuip')) {
            return 'fuip';
        } else if (this.router.url.includes('disputesfaq')) {
            return 'creditfaq';
        } else if (this.router.url.includes('payments')) {
            return 'payments';
        } else if (this.router.url.includes('interstitial')) {
            return 'interstitial';
        } else if (this.router.url.includes('citialert')) {
            return 'citialert';
        }
        else if (this.router.url.includes('statements')) {
            return 'statements';
        }
        else {
            return 'unknown';
        }
    }

    setInterstitialsCollect(interstitialsCollect: string) {
        this.interstitialsCollect = interstitialsCollect;
    }

    getInterstitialsCollect(): string {
        return this.interstitialsCollect;
    }

    removeSessionStore(){
        sessionStorage.removeItem('identifyE4SignOnEvent');
        sessionStorage.removeItem('signonSuccessTriggered');
        sessionStorage.removeItem('loginInterstitialData');
        sessionStorage.removeItem('se_errormsg');
        sessionStorage.removeItem('selectedCardAccountUUID');
        sessionStorage.removeItem("siteLocal_ID");
        sessionStorage.removeItem('skipAdobeScript');
        sessionStorage.removeItem('loginType');
        sessionStorage.removeItem('uauthtoken');
    }
  
    public getDeviceType() {
        let check = window.navigator.userAgent;
        if (check.match(/Mobile/) && (check.match(/iPhone/) || check.match(/Android/))) {

            return "MOBILE";
        }
        else if (!check.match(/Mobile/) && (check.match(/Safari/) || check.match(/Chrome/))) {

            return "DESKTOP";
        }
        else {

            return "TABLET";
        }
    }

    public getScreenCapture(module_name, view_name, page_name, template_name, area_name?, desc_text?) {
        var descText = this.getParams().desc;
        this.screenCaptureObj['deviceType'] = this.getDeviceType();
        this.screenCaptureObj['moduleName'] = module_name;
        this.screenCaptureObj['moduleViewName'] = view_name;
        this.screenCaptureObj['orientationName'] = this.getScreenPosition();
        this.screenCaptureObj['page'] = page_name;
        //To be worked on getting actual screen view
        this.screenCaptureObj['screenView'] = this.getScreenView();
        this.screenCaptureObj['templateName'] = template_name;
        this.screenCaptureObj['areaName'] = area_name;
        this.screenCaptureObj['desc'] = descText ? descText : desc_text;
        return this.screenCaptureObj;
    }

    setSecurityQuestionsResponse(sqResponse: any): void {
        this.securityQuestionsResponse = sqResponse;
    }

    getSecurityQuestionsResponse(): any {
        return this.securityQuestionsResponse;
    }

    emitFreezeCardSelector(show: boolean) {
        this.disableCardSeletorDropDown.next(show);
    }

    redirectToFusionAngular(href: string): void {
        if (!href || !routeMapping[href]) {
            href = 'dashboard'
        }

        let { routePath, pageName, basePath = 'RSag', faqCategory } = routeMapping[href];
        const currentSearchParams = new URLSearchParams(window.location.search);
        currentSearchParams.delete('pagename');
        currentSearchParams.delete('pageName');
        if (href == 'incomecapture') {
            currentSearchParams.set('pageName', 'profile');
            routePath = 'profile';
            currentSearchParams.set('module', 'incomecapture');
        } else {
            currentSearchParams.set('pageName', pageName);
        }
        if (faqCategory) {
            currentSearchParams.set('faqCategory', faqCategory);
        }

        if (sessionStorage.getItem('prev_screen_params')) {
            const currrentKeyParams = [];
            currentSearchParams.forEach((value, key) => {
                currrentKeyParams.push(key?.toLowerCase());
            });
            const preParam = sessionStorage.getItem('prev_screen_params');
            sessionStorage.removeItem('prev_screen_params');
            preParam.split('&').forEach(param => {
                const [key, value] = param.split('=');
                if (key && value && !currrentKeyParams.includes(key?.toLowerCase())) {
                    currentSearchParams.set(key, value);
                }
            })
        }

           window.location.href = `/${basePath}/${routePath}?${this.sortParams(currentSearchParams)}`;

    }

    sortParams(params: URLSearchParams): string {

        const requiredOrder = ['pageName', 'siteId', 'langId', 'faqCategory', 'module'];

        const orderedParams = new URLSearchParams();

        // Add required params in order (preserving all values for multi-value params)

        for (const key of requiredOrder) {

            const values = params.getAll(key);

            for (const value of values) {

                orderedParams.append(key, value);

            }

        }

        // Collect remaining keys, sort alphabetically for deterministic output

        const remainingKeys: string[] = [];

        params.forEach((_value, key) => {

            if (!requiredOrder.includes(key) && !remainingKeys.includes(key)) {

                remainingKeys.push(key);

            }

        });

        remainingKeys.sort();

        // Add remaining params in sorted order

        for (const key of remainingKeys) {

            const values = params.getAll(key);

            for (const value of values) {

                orderedParams.append(key, value);

            }

        }

        return orderedParams.toString();

    }

    createHeaderData(): { siteId: string; "Accept-Language": string } {
        const urlParameters = this.getParams();
        const langId = urlParameters?.langId || 'en_US';
        const siteId = this.getSiteId();

        let acceptLanguage = langId;

        if (siteId === "CACN_HOMEDEPOT") {
            const languageMap = {
                en_US: { acceptLanguage: 'ca_US', langId: 'en_CA' },
                en_CA: { acceptLanguage: 'ca_US', langId: 'en_CA' },
                ca_US: { acceptLanguage: 'ca_US', langId: 'en_CA' },
                fr_US: { acceptLanguage: 'fr_US', langId: 'fr_CA' },
                fr_CA: { acceptLanguage: 'fr_US', langId: 'fr_CA' }
            };

            if (languageMap[langId]) {
                acceptLanguage = languageMap[langId].acceptLanguage;
            }
        } else {
            // For all other sites, use langId as-is (keeping underscore format)
            acceptLanguage = langId;
        }

        return {
            "siteId": siteId,
            "Accept-Language": acceptLanguage
        };
    }

    /**
     * Sanitizes error text for analytics/logging by stripping HTML and normalizing whitespace.
     */
    public sanitizeErrorText(html: string): string {
        if (!html) {
            return '';
        }

        try {
            // Sanitize the HTML to strip all tags and attributes, leaving only text content.
            // DOMPurify is highly optimized and secure against XSS bypasses.
            const cleanHtml = DOMPurify.sanitize(html, {
                ALLOWED_TAGS: [], // Strips all HTML tags
                ALLOWED_ATTR: []  // Strips all attributes
            });

            const parser = new DOMParser();
            const doc = parser.parseFromString(cleanHtml, 'text/html');

            // Replace non-breaking spaces and trim
            return (doc.body.textContent || '').replace(/\u00A0/g, ' ').trim();
        } catch (error) {
            // Avoid logging the raw error object to prevent Information Disclosure (CWE-209)
            const errorMessage = error instanceof Error ? error.message : 'Unknown error';
            console.error('Sanitization failed:', errorMessage);
            return '';
        }
    }
}
